import { render, staticRenderFns } from "./titleButton.vue?vue&type=template&id=69503236&scoped=true"
import script from "./titleButton.vue?vue&type=script&lang=ts"
export * from "./titleButton.vue?vue&type=script&lang=ts"
import style0 from "./titleButton.vue?vue&type=style&index=0&id=69503236&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69503236",
  null
  
)

export default component.exports